import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Image,
  Portal,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useNavigate, useParams } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import Footer from "../../../components/common/Footer";
import Loading from "../../../components/common/Loading";
import SafeSecure from "../../../components/common/SafeSecure";
import { CourseEnrolmentModal } from "../../../components/trainee/enrolment/enrolment-modal";
import cmd from "../../../img/cmd.svg";
import mounted from "../../../img/mounted.svg";
import notes from "../../../img/notes.svg";
import Engineer from "../../../img/selEngineers.svg";
import { IAllCourse } from "../../../models/allcourse.model";
import { IAvailableCourse } from "../../../models/trainee-course.model";
import registrationService from "../../../services/registration.service";

const MyCourse = () => {
  const navigate = useNavigate();
  const { course_id } = useParams();
  const [course, setCourse] = useState<IAllCourse>();
  const [course_available, setCourseAvailable] = useState<IAvailableCourse>();
  const [loading, setLoading] = useState(true);
  const [isEnrol, setEnrol] = useState(false);
  const [reload, setReload] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const availableCourse = sessionStorage.getItem("available_course");

    if (availableCourse) {
      setCourseAvailable(JSON.parse(availableCourse));
    }
    registrationService
      .getEachCourse(course_id)
      .then((response) => {
        setCourse(response);
        setLoading(false);
      })
      .catch((err) => err);
  }, []);

  const openEnrolModal = async () => {
    setEnrol(true);
    onOpen();
  };
  const reloadData = () => {
    setReload(!reload);
  };

  return (
    <>
      <DashboardHeader />
      {loading ? (
        <Loading />
      ) : (
        <Box>
          <Flex bg="#2557D6" height="500px">
            <Box width={["100%", "100%", "50%", "50%"]}>
              <Box pt="80px" px="5%">
                <Text
                  fontSize="39px"
                  color="white"
                  fontWeight="800"
                  textAlign="left"
                >
                  {course && course.name}
                </Text>

                <Text
                  mt="25px"
                  fontSize="18px"
                  textAlign="left"
                  fontWeight="400"
                  color="white"
                >
                  {course?.description ? course.description : "Nil"}
                </Text>
                <Text textAlign="left" mb="50px">
                  <Button
                    py="7px"
                    px="10px"
                    mt="30px"
                    borderRadius={2}
                    onClick={() => openEnrolModal()}
                    colorScheme="red"
                    size="sm"
                  >
                    ENROLL NOW
                  </Button>
                </Text>
              </Box>
            </Box>
            <Box width="50%" display={["none", "none", "flex", "flex"]}>
              {course?.cover_image ? (
                <Image
                  objectFit="fill"
                  height="100%"
                  width="100%"
                  src={course?.cover_image}
                />
              ) : (
                <Image
                  objectFit="fill"
                  height="100%"
                  width="100%"
                  src={Engineer}
                />
              )}
            </Box>
          </Flex>

          <Flex
            alignItems="center"
            mb="60px"
            justifyContent="space-between"
            bg="#F9F9F9"
            px={["20px", "20px", "60px", "110px"]}
            py={["20px", "20px", "40px", "40px"]}
            gap="1rem"
          >
            <HStack
              spacing={["10px", "10px", "15px", "25px"]}
              flexDirection={["column", "column", "row", "row"]}
              mb="auto"
            >
              <Center
                width="50px"
                height="50px"
                bg="gray.200"
                borderRadius="25px"
              >
                <Image src={notes} />
              </Center>

              <VStack>
                <Text color="#616161" fontSize="13px" fontWeight="400">
                  {" "}
                  Program Type
                </Text>
                <Text fontSize="15px" fontWeight="600">
                  {" "}
                  {course && course.type && course?.type.name}
                </Text>
              </VStack>
            </HStack>
            <HStack
              spacing={["10px", "10px", "15px", "25px"]}
              flexDirection={["column", "column", "row", "row"]}
              mb="auto"
            >
              <Center
                width="50px"
                bg="gray.200"
                height="50px"
                borderRadius="25px"
              >
                <Image src={cmd} />
              </Center>
              <VStack>
                <Text color="#616161" fontSize="13px" fontWeight="400">
                  Course Code
                </Text>
                <Text fontSize="15px" fontWeight="600">
                  {course?.code}
                </Text>
              </VStack>
            </HStack>
            <HStack
              spacing={["10px", "10px", "15px", "25px"]}
              flexDirection={["column", "column", "row", "row"]}
              mb="auto"
            >
              <Center
                width="50px"
                bg="gray.200"
                height="50px"
                borderRadius="25px"
              >
                <Image src={mounted} />
              </Center>

              <VStack>
                <Text color="#616161" fontSize="13px" fontWeight="400">
                  {" "}
                  Program Category
                </Text>
                <Text fontSize="15px" fontWeight="600">
                  {course && course.category && course?.category.name}
                </Text>
              </VStack>
            </HStack>
          </Flex>

          <Flex
            alignItems="center"
            justifyContent="space-between"
            flexDirection={["column", "column", "row", "row"]}
            px={["20px", "20px", "50px", "100px"]}
            mb={["40px", "40px", "70px", "150px"]}
          >
            <Box width={["100%", "100%", "100%", "40%"]}>
              <Text fontSize="42px" fontWeight="800" mb="30px">
                About Course
              </Text>
              <Text fontSize="18px" fontWeight="500" color="#616161">
                {course?.description}
              </Text>
            </Box>
            <Box width={["100%", "100%", "100%", "60%"]}>
              <Flex justifyContent="space-between">
                <Box>
                  <Text color="#959595" fontSize="14px">
                    COST (NGN)
                  </Text>
                  <Text fontSize="20px">
                    <NumericFormat
                      value={course?.cost}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                  </Text>
                </Box>
                <Box>
                  <Text color="#959595" fontSize="14px">
                    MIN. DEPOSIT
                  </Text>
                  <Text fontSize="20px">
                    <NumericFormat
                      value={course?.min_deposit}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"₦"}
                    />
                  </Text>
                </Box>
                <Box>
                  <Text color="#959595" fontSize="14px">
                    INSTALLMENTS
                  </Text>
                  <Text fontSize="20px">{course?.installment}</Text>
                </Box>
              </Flex>
              <Text color="#959595" fontSize="14px" pt="17px" pb="12px">
                ELIGIBILITY
              </Text>
              <Text color="#959595" fontSize="14px">
                Transmission lines maintenance engrs Transmission lines
                maintenance senoir technicians Transmission line maintenance
                supervisors
              </Text>
            </Box>
          </Flex>
        </Box>
      )}

      <SafeSecure />

      <Footer />
      {isEnrol && (
        <Portal>
          {" "}
          <CourseEnrolmentModal
            isOpen={isOpen}
            onClosed={onClose}
            isEnrol={isEnrol}
            reload={reloadData}
            data={course_available}
          />{" "}
        </Portal>
      )}
      <Box />
    </>
  );
};

export default MyCourse;
